import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Button, Form, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
//redux
import { cartSelector, clear, setBillingCartAddress } from 'slices/cart';
import { companySelector } from 'slices/company';
import { userSelector, setBillingAddress } from 'slices/user';
//api
import { getInfoRedsys, redsysProcessCopyDeactivateCart, updateCartDetails } from 'api/ecommerce';
import { infoUser, saveChanges } from 'api/users';
import { updateCartSituationBankTransfer } from 'api/orders';
//helpers
import { goUp } from 'helpers';
import { formatCurrency } from 'utils/currencyFormatter';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import TPV from './tpv';
import OrderSummary from 'components/cart/OrderSummary';
import OrderStepper from 'components/cart/OrderStepper';
import CustomTab from 'components/Tab';
import AddressForm from 'components/addressForm';
//styles
import './cart.scss';

const Pay = () => {
  const { t } = useTranslation(['payment', 'shipping']);
  const dispatch = useDispatch();
  const { id: bookstoreId, data, name, enabled_countries } = useSelector(companySelector);
  const { billingAddress, benefitedBookstore, firstName, lastName, email, phoneNumber, id, pickUpLibrary } = useSelector(userSelector);
  const { isStorePickup, items, giftData, total, appliedCoupon, billingCartAddress, shippingCartAddress, contactInfo } = useSelector(cartSelector);

  const [addDirection, setAddDirection] = useState(false);
  const [processOrderBankTransferSuccess, setProcessOrderBankTransferSuccess] = useState(false);
  const [detailOrder, setDetailOrder] = useState({});
  const [validData, setValidData] = useState([false, t('completeFields', { ns: 'shipping' })]);
  // type of payment
  const [isCardPayment, setIsCardPayment] = useState(true);
  //info redsys
  const [infoRedsys, setInfoRedsys] = useState(null);
  const { assignedLibrary } = useAssignedLibrary();

  const initialBillingValue = () => {
    if (billingAddress) {
      return {
        ...billingAddress,
        email: email || '',
        first_name: firstName || '',
        last_name: lastName || '',
        phone: billingAddress.phone || phoneNumber || '',
      };
    } else {
      return {
        address: '',
        postal_code: '',
        first_name: firstName || '',
        last_name: lastName || '',
        locality: '',
        province: '',
        country: '',
        email: email || '',
        phone: phoneNumber || '',
      };
    }
  };

  const [updateDataBilling, setUpdateDataBilling] = useState(() => initialBillingValue());

  useEffect(() => {
    goUp();
    window.document.title = t('seoTitle') + name;
    const fromRedsys = JSON.parse(localStorage.getItem('historyRedsys'));

    if (fromRedsys) {      //! DESACTIVAR EL CARRO ACTUAL Y CREAR NUEVO A TRAVES DE EP, REDIRIGIR A CART STEP IN PROCESS
      localStorage.removeItem('historyRedsys');
      handleCopyCurrentCartRedsysProccess();
    }
    dispatch(setBillingCartAddress(updateDataBilling));
  }, []);

  useEffect(() => {
    const checkData = () => {
      if (updateDataBilling !== undefined) {
        let properties = ['first_name', 'address', 'postal_code', 'locality'];
        for (let i of properties) {
          if (updateDataBilling[`${i}`] === undefined || updateDataBilling[`${i}`] === '') {
            setValidData([false, t('completeFields', { ns: 'shipping' })]);
            return '';
          }
        }
        setValidData([
          true,
          updateDataBilling.address + ', ' + updateDataBilling.postal_code + ', ' + updateDataBilling.locality,
        ]);
      }
    };
    checkData();
  }, [updateDataBilling]);

  const handleChangeSave = async (values) => {
    let payload = {
      first_name: values?.first_name,
      last_name: values?.last_name,
      email: values?.email,
      phone: values?.phone,
      address: values?.address,
      country: values?.country,
      province: values?.province?.label,
      locality: values?.locality,
      postal_code: values?.postal_code,
    };
    try {
      const changes = await saveChanges({ billing_address: payload }, id);
      if (changes.status === 200) {
        dispatch(setBillingAddress(payload));
        setAddDirection(false)
      }
    } catch (error) {
      console.error(error)
    }
  };

  const handleCopyCurrentCartRedsysProccess = async () => {    //! CAMBIA ESTADO DEL CARRO ACTUAL A DESACTIVADO Y CREA UNA COPIA PARA CONTROL RETORNO SIN PAGO DE REDSYS
    try {
      const response = await redsysProcessCopyDeactivateCart({ items });
    } catch (error) {
      console.error(`Error ep - redsysProcessCopyDeactivateCart: ${error}`);
    }
  };

  const handleUpdateCartDetails = async () => {
    const payload = {
      items: items,
      empresa: bookstoreId,
      store_pickup: isStorePickup,
      billing_address: billingCartAddress,
      shipping_address: shippingCartAddress,
      bookstore_to_pickup: pickUpLibrary,
      benefited_company: benefitedBookstore?.value,
      contact_info: contactInfo,
    };
    try {
      const response = await updateCartDetails(payload);
    } catch (error) {
      console.error('Error updating cart details', error);
    }
  };

  const handleCartBankTransfer = async () => {
    try {
      await handleUpdateCartDetails();
      const { status, data } = await updateCartSituationBankTransfer(); //! CREA PEDIDO Y CAMBIA ESTADO CARRO A DESACTIVADO SOLO USO XRA PAGO X TRANSF BANCARIA
      if (status === 200) {
        setDetailOrder(data);
        setProcessOrderBankTransferSuccess(true);
        dispatch(clear());
      }
    } catch (error) {
      console.error(error);
    }
  };

  const callGetInfoRedsys = async () => {
    let payload = { applied_coupon: appliedCoupon };
    try {
      const { status, data } = await getInfoRedsys(payload);
      if (status === 200) {
        setInfoRedsys(data);
      }
    } catch (error) {
      console.error('Error getInfoRedsys', error);
    }
  };

  useEffect(() => {
    if (isCardPayment) {
      callGetInfoRedsys();
    }
  }, [isCardPayment]);

  return (
    <Container fluid className="sm-fluid mainDiv">
      {!processOrderBankTransferSuccess ? (
        <Row className="justify-content-center">
          <Col md={9}>
            <OrderStepper activeStep={2} />

            <Row className="tabs-row">
              <Col md={12} lg={12} xs={12} className="ml-1">
                <div>
                  <h2 onClick={() => console.log('click h2', giftData)} className="mt-3">
                    {t('billingAddress')}
                  </h2>

                  <CustomTab
                    customClass="custom-tab"
                    tabs={[
                      {
                        title: t('billingAddress'),
                        id: 'billingAddress',
                        renderContent: () => {
                          return !addDirection ? (
                            <Col lg={12} className="mt-2 d-flex justify-content-center">
                              <Row className="mt-2 w-100 d-flex justify-content-center">
                                <Col lg={8} md={8} sm={12} xs={12} className="mb-3 mb-md-0">
                                  <Form.Control value={validData[1]} disabled className={`mr-2 pl-0 ${!validData[0] && 'border-danger text-danger'}`} />
                                </Col>
                                <Col lg={4} md={4} sm={12} xs={12} className="d-flex justify-content-center">
                                  <Button className="white-btn py-2 px-0" onClick={() => setAddDirection(!addDirection)}>
                                    {t('editAddress').toUpperCase()}
                                  </Button>
                                </Col>
                              </Row>
                            </Col>
                          ) : (
                            <AddressForm
                              data={updateDataBilling}
                              onChange={(newData) => {
                                setUpdateDataBilling(newData);
                                dispatch(setBillingCartAddress(newData));
                              }}
                              onCancel={() => {
                                setUpdateDataBilling(billingAddress);
                                dispatch(setBillingCartAddress(billingAddress));
                                setAddDirection(false)
                              }}
                              onSave={() => handleChangeSave(updateDataBilling)}
                              countries={enabled_countries}
                              additionalInfoHeader={t('addressAndBillingData')}
                              isBillingAddressDetails={true}
                            />
                          );
                        },
                      },
                    ]}
                  ></CustomTab>
                </div>

                <div className="">
                  <h2 className="mt-3">{t('paymentMethod')}</h2>
                  <div className="giftDiv">
                    <Row className="giftDiv--row">
                      <Form.Check
                        type="radio"
                        className="payment-type"
                        onChange={() => {
                          setIsCardPayment(true);
                        }}
                        checked={isCardPayment}
                      />
                      <p className="payment-type__text">{t('cardPayment')}</p>
                    </Row>
                    <Row className="giftDiv--row">
                      <Form.Check
                        type="radio"
                        className="payment-type"
                        onChange={() => {
                          setIsCardPayment(false);
                        }}
                        checked={!isCardPayment}
                      />
                      <p className="payment-type__text">{t('bankTransfer')}</p>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="discount mt-5">
              <Col md={12} lg={12} xs={12} className="d-flex justify-content-between">
                <span>
                  <Button
                    className="orange-btn p-2 text-white"
                    as={Link}
                    to={{
                      pathname: `/${assignedLibrary}/envio`,
                    }}
                    size="sm"
                  >
                    {t('goBack').toUpperCase()}
                  </Button>
                </span>
                <span className="d-flex">
                  <p className="pt-2 mr-3 mx-3">{t('allSet')}</p>
                  {isCardPayment ? (
                    <TPV redsys={infoRedsys} infoDataDisabled={!validData[0]} />
                  ) :
                    !validData[0] ?
                      <OverlayTrigger
                        overlay={<Tooltip id="button-tooltip2">{t('completeFields', { ns: 'shipping' })}</Tooltip>}
                      >
                        <span className="d-inline-block">
                          <Button
                            className="orange-btn p-2 text-white max-h-39 disabled"
                            disabled
                            size="sm"
                          >
                            {t('buyNow').toUpperCase()}
                          </Button>
                        </span>
                      </OverlayTrigger> :
                      <Button
                        onClick={() => {
                          if (!isCardPayment) {
                            handleCartBankTransfer(true);
                          }
                        }}
                        className="orange-btn p-2 text-white max-h-39"
                        size="sm"
                      >
                        {t('buyNow').toUpperCase()}
                      </Button>
                  }
                </span>
              </Col>
            </Row>
          </Col>

          {total && <OrderSummary />}
        </Row>
      ) : (
        <div className="text-center">
          <p>{t('orderSuccess')}</p>
          <p>{t('receiveMailOrder')}</p>
          <Row className="justify-content-center">
            <Col md={10}>
              <Table bordered hover variant="dark">
                <tbody>
                  <tr>
                    <td colSpan="2">
                      <h3>{t('makeTransfer')}</h3>{' '}
                    </td>
                  </tr>
                  <tr>
                    <td>{t('bankAccount')}</td>
                    <td>{data?.cif}</td>
                  </tr>
                  <tr>
                    <td>{t('concept')}</td>
                    <td>{detailOrder?.order} </td>
                  </tr>
                  <tr>
                    <td>{t('totalTransfer')}</td>
                    <td>{formatCurrency(detailOrder?.total)}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col md={8} className="container-messge-transfer">
              <p>
                {t('messageTransfer')}
                <b>{data?.cif}</b> {t('messageNumberOrder')}
                <b>{detailOrder?.order}</b>.
              </p>
              <p>{t('bankTransferDelayOrder')}</p>
              <p>{t('thanks')}</p>
              <Button className="mt-3 p-3" as={Link} to="/">
                {t('backHome')}
              </Button>
            </Col>
          </Row>
        </div>
      )}
    </Container>
  );
};

export default Pay;